// extracted by mini-css-extract-plugin
export default {"info":"MoreCustomers_info__s1GCe","btns":"MoreCustomers_btns__J8L3p","button":"MoreCustomers_button__3JpeY"};